import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

import * as wjcCore from '@mescius/wijmo';

import { allComponents, provideFluentDesignSystem, } from '@fluentui/web-components';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

export const FluentDesignSystem = provideFluentDesignSystem().register(
    allComponents
);

async function initialize() {
    try {
        console.log('Office is ready! Booting Angular app...');
        await Office.onReady(async (info) => {
            await bootstrapApplication(AppComponent, appConfig());
        });
        console.log('Angular app bootstrapped successfully.');
    }
    catch(err) {
        console.error('Office failed to initialize', err);
    }
}

initialize().then(r => console.log('Office Add-In started successfully. Press F12 to open the developer tools and check the console for any errors.'));


